import { useRef, useState } from "react";
import "./Login.css";

import { useNavigate } from "react-router-dom";

import Modal from "../../ModalWindow/Modal.tsx";
import blackLogo from "../../../svg/erkon black.png";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setAuth } from "../../../slices/managerSlice";
import ConnectionError from "../../ConnectionError/ConnectionError";

function Login() {
  const navigate = useNavigate();

  const [login, setLogin] = useState("");
  const [pass, setPass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isError, setIsError] = useState(false);
  const [networkError, setNetworkError] = useState(null);

  const [isButtonActive, setIsButtonActive] = useState(true);
  const [buttonTxt, setButtonTxt] = useState("Войти");
  const canSubmit =
    login.trim().length >= 4 && pass.length >= 4 && isButtonActive;
  const loginInputRef = useRef(null);
  const passwordInputRef = useRef(null);

  const dispatch = useDispatch();

  const closeModal = () => {
    setIsError(false);
  };

  localStorage.setItem("theme", "light");

  const theme = localStorage.getItem("theme");
  document.documentElement.dataset.theme = theme;

  async function tryVerifyPhone(event) {
    event?.preventDefault();
    if (!canSubmit) return;
    setIsButtonActive(false);
    setButtonTxt("Загрузка...");
    setIsError(false);
    setNetworkError(null);

    try {
      const response = await axios.get(
        `https://api-erkon.tech/mobile/hs/ObmenMP/auth/${login}/${pass}`,
        { timeout: 15000 },
      );

      if (response.status === 200) {
        const data = await response.data;

        if (data.token) {
          localStorage.setItem("tokenMANAGER", data.token);
          dispatch(setAuth());
          navigate("/requests");
        } else {
          setIsError(true);
        }
      } else {
        setIsError(true);
      }
    } catch (error) {
      const responseData = error.response?.data;
      const errorText =
        typeof responseData === "string"
          ? responseData
          : responseData?.text || responseData?.message || "";
      if (
        [400, 401, 403, 422].includes(error.response?.status) ||
        /неверн.*(логин|парол)/i.test(errorText)
      ) {
        setIsError(true);
      } else {
        setNetworkError(error.response?.status || "network");
      }
    } finally {
      setIsButtonActive(true);
      setButtonTxt("Войти");
    }
  }

  return (
    <div className="fullBody">
      <div className="logoPlaceholder">
        <img src={blackLogo} className="logo" alt="logo" />
      </div>

      <form style={{ width: "100%" }} onSubmit={tryVerifyPhone}>
        <div className="numberInputPlaceholder">
          <span className="numberInputTitle">Введите свой логин и пароль</span>

          <div className="phoneNumberInput">
            <div className="loginField">
              <div className="loginFieldContent">
                <label className="loginFieldLabel" htmlFor="login-input">
                  Логин
                </label>
                <input
                  ref={loginInputRef}
                  id="login-input"
                  className="loginXd"
                  type="text"
                  autoComplete="username"
                  value={login}
                  onChange={(event) => {
                    setLogin(event.target.value);
                    setNetworkError(null);
                  }}
                />
              </div>
              {login && (
                <button
                  type="button"
                  className="loginFieldAction"
                  aria-label="Очистить логин"
                  onClick={() => {
                    setLogin("");
                    setNetworkError(null);
                    loginInputRef.current?.focus();
                  }}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M5 5l14 14M19 5L5 19" />
                  </svg>
                </button>
              )}
            </div>
            <div className="loginField">
              <div className="loginFieldContent">
                <label className="loginFieldLabel" htmlFor="password-input">
                  Пароль
                </label>
                <input
                  key={showPassword ? "visible-password" : "hidden-password"}
                  ref={passwordInputRef}
                  id="password-input"
                  className="loginXd"
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  value={pass}
                  onChange={(event) => {
                    setPass(event.target.value);
                    setNetworkError(null);
                  }}
                />
              </div>
              <button
                type="button"
                className="loginFieldAction"
                aria-label={showPassword ? "Скрыть пароль" : "Показать пароль"}
                aria-pressed={showPassword}
                onClick={() => setShowPassword((visible) => !visible)}
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" />
                  <circle cx="12" cy="12" r="3" />
                  {showPassword && <path d="M3 21 21 3" />}
                </svg>
              </button>
              {pass && (
                <button
                  type="button"
                  className="loginFieldAction"
                  aria-label="Очистить пароль"
                  onClick={() => {
                    setPass("");
                    setNetworkError(null);
                    passwordInputRef.current?.focus();
                  }}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M5 5l14 14M19 5L5 19" />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="footerSendButton">
          <div className="sendButtonPlaceholder">
            <button
              type="submit"
              disabled={!canSubmit}
              className={canSubmit ? "sendButtonActive" : "sendButton"}
            >
              {buttonTxt}
            </button>
          </div>
        </div>
      </form>
      {networkError && (
        <ConnectionError
          status={networkError}
          title="Не удалось войти"
          hint="Проверьте соединение. Возможно, логин или пароль введены неправильно."
          onRetry={() => tryVerifyPhone()}
        />
      )}

      <Modal
        title="Неверный логин или пароль"
        isConfirming={false}
        active={isError}
        onClose={closeModal}
      ></Modal>
    </div>
  );
}

export default Login;
